// Copyright (c) 2021 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../actions-list';
import {buildPayload} from '../services/build-payload';
import {getSelectedDealersLaborRate} from '../../shared/repositories';
import {translate} from '../../../shared/services/translation-service';
import {warningAlertBar} from '../../../shared/services/alert-bar';

export const readSelectedLaborRates = accounts =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        const payload = buildPayload(accounts, false);

        try {

            const dealerLaborRates = await getSelectedDealersLaborRate(payload);

            dispatch({
                data: dealerLaborRates,
                type: actions.SET_SELECTED_ACCOUNT_LABOR_RATES
            });
            if (dealerLaborRates[0].salesOffDiff) {

                warningAlertBar(translate('COMMON_LABOR_TYPES_WARNING'));

            }

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/claim/mass-labor-rate-change/action-creators/read-selected-labor-rates.js